import React from 'react';
import { Redirect } from 'react-router-dom';
import AccountSecurity from './components/AccountSecurity';
import Modal from '../../components/Modal/Modal';
import { AuthContext } from '../../context/Auth/Auth';
import modalReducer, { initialState } from '../../reducers/Modal.reducer';

const AccountSecurityPage = () => {
  const [state, dispatch] = React.useReducer(modalReducer, initialState);
  const { isLoggedIn } = React.useContext(AuthContext);

  const closeModal = React.useCallback(() => {
    dispatch({ type: 'CLOSE_MODAL' });
  }, []);

  const showModalError = React.useCallback((errorMessage: string) => {
    dispatch({ type: 'SHOW_MODAL_ERROR', payload: errorMessage });
  }, []);

  if (!isLoggedIn) return <Redirect to="/login" />;

  return (
    <React.Fragment>
      <AccountSecurity showModalError={showModalError} />
      <Modal show={state.showModal} error={state.error} errorMessage={state.errorMessage} closeModal={closeModal} />
    </React.Fragment>
  );
};

export default AccountSecurityPage;
